module.exports = __webpack_public_path__ + "static/media/s_33.adb5bf90.mp3";